<div class="placement-excellence-container-fluid">
    <div class="row">
        <div *ngFor="let item of tableItems">
            <div class="col">
                <app-placement-excellence-content-card coreStep="{{item.coreStep}}" generalTask="{{item.generalTask}}" actionDetails="{{item.actionDetails}}" responsibility="{{item.responsibility}}" cemRequirement="{{item.cemRequirement}}" guidanceReferenceLink="{{item.guidanceReferenceLink}}">
                </app-placement-excellence-content-card>
            </div>
        </div>
    </div>
</div>